import React, { useEffect } from "react";
import { Subscribe } from "unstated";
import { t } from "@lingui/macro";
import { i18n, Profile, Metabar } from "idc-ui-react";
// Our Modules
import { store } from "../../stores/Main";
import Hero from "./Hero/index";
import { Section } from "../../components";
import {
  Stack,
  DefaultPalette,
  MessageBar,
  MessageBarType,
  Text
} from "@fluentui/react";

const ProfilePage = ({ store }) => {
  const { state, setAsPrimaryPosition, notifications } = store;
  const { loggedInUser, errorSavingItem, errorMessage } = state;
  const { tenant } = loggedInUser;
  const urls = store.urls;
  const apiCall = store.apiCall;

  useEffect(() => {
    if (errorSavingItem && errorMessage) {
      notifications.setError(() => errorMessage);
    }
    store.setState({ errorSavingItem: false });
    // eslint-disable-next-line
  }, [errorSavingItem]);

  return loggedInUser ? (
    <>
      <Metabar store={store} />
      <Section hero returnLink>
        <Stack
          verticalFill
          styles={{
            root: {
              backgroundColor: DefaultPalette.white,
              borderRadius: 4,
              height: "100%",
              padding: 24
            }
          }}
        >
          <Hero profile={loggedInUser} />
          <Stack
            styles={{
              root: {
                borderBottom: `2px solid ${DefaultPalette.themePrimary}`,
                paddingTop: 24
              }
            }}
          />
          <Stack styles={{ root: { paddingTop: 10, paddingBottom: 10 } }}>
            {loggedInUser.positions.length > 0 &&
              !loggedInUser.positions.some(p => p.primary) && (
                <MessageBar
                  messageBarType={MessageBarType.warning}
                  messageBarIconProps={{
                    iconName: "FavoriteStar",
                    styles: {
                      root: {
                        color: "#ffaa44"
                      }
                    }
                  }}
                  overflowButtonAriaLabel="See more"
                  onDismiss={null}
                  dismissButtonAriaLabel="Close"
                >
                  <Text>
                    <b>{i18n._(t`Note`)}: </b>
                    {i18n._(
                      t`Please select a primary employment by clicking on the star on the employment.`
                    )}
                  </Text>
                </MessageBar>
              )}
          </Stack>
          <Profile
            item={loggedInUser}
            tenant={tenant}
            setAsPrimaryPosition={setAsPrimaryPosition}
            apiCall={apiCall}
            urls={urls}
          />
        </Stack>
      </Section>
    </>
  ) : (
    <></>
  );
};

const StoreWrapper = props => (
  <Subscribe to={[store]}>
    {store => <ProfilePage {...props} store={store} />}
  </Subscribe>
);

export default StoreWrapper;
